// Structured Data (Schema.org JSON-LD) for SEO

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Close CRM Agentur',
  alternateName: 'Close CRM Agentur.de',
  url: 'https://close-crm-agentur.de',
  logo: 'https://cdn.magicpatterns.com/uploads/3FWPoSStYkTeUgaax2MNNb/Close_PartnerBadge_Top10_24.png',
  description:
    'Die führende Close CRM Agentur im deutschsprachigen Raum. Wir implementieren Close CRM für skalierbaren Vertrieb mit 47% mehr Abschlüssen.',
  foundingDate: '2022',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+49-157-35999071',
    contactType: 'Sales',
    email: 'justus@crm-kraft.de',
    availableLanguage: ['German', 'English'],
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: '7901 4th St. N, Ste. 300',
    addressLocality: 'St. Petersburg',
    addressRegion: 'FL',
    postalCode: '33702',
    addressCountry: 'US',
  },
}

export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: 'Close CRM Agentur',
  image:
    'https://cdn.magicpatterns.com/uploads/3FWPoSStYkTeUgaax2MNNb/Close_PartnerBadge_Top10_24.png',
  '@id': 'https://close-crm-agentur.de',
  url: 'https://close-crm-agentur.de',
  telephone: '+49-157-35999071',
  email: 'justus@crm-kraft.de',
  priceRange: '€€€',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '7901 4th St. N, Ste. 300',
    addressLocality: 'St. Petersburg',
    addressRegion: 'FL',
    postalCode: '33702',
    addressCountry: 'US',
  },
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '09:00',
    closes: '18:00',
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    reviewCount: '110',
  },
}

export const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'CRM Implementation & Consulting',
  provider: {
    '@type': 'Organization',
    name: 'Close CRM Agentur',
  },
  areaServed: {
    '@type': 'Country',
    name: 'Germany',
  },
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Close CRM Services',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Close CRM Consulting',
          description:
            'Strategische Beratung und Basis-Setup für den schnellen Start mit Close CRM',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Close CRM Set Up',
          description:
            'Vollständige Close CRM Implementierung mit Automatisierungen, Integrationen und Team-Training',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Managed Service',
          description:
            'Laufende CRM-Betreuung, Optimierung und Priority Support',
        },
      },
    ],
  },
}

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Close CRM Agentur',
  url: 'https://close-crm-agentur.de',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://close-crm-agentur.de/?s={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
}

export const breadcrumbSchema = (items: { name: string; url: string }[]) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url,
  })),
})

export const faqSchema = (faqs: { question: string; answer: string }[]) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
})

export const reviewSchema = (
  reviews: {
    author: string
    rating: number
    text: string
    date: string
  }[],
) => ({
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: 'Close CRM Implementation Services',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    reviewCount: reviews.length.toString(),
  },
  review: reviews.map((review) => ({
    '@type': 'Review',
    author: {
      '@type': 'Person',
      name: review.author,
    },
    datePublished: review.date,
    reviewRating: {
      '@type': 'Rating',
      ratingValue: review.rating.toString(),
      bestRating: '5',
    },
    reviewBody: review.text,
  })),
})
